import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import BreadcrumbCompany from "../BreadcrumbCompany";
import LogoProduct from "./Products/LogoProduct";
import ShoppingCart from "./Checkout/ShoppingCart";
import { useEffect, useState } from "react";
import { WebshopProductModel } from "models/WebShop";
import AddToCartModal from "components/AddToCartModal";
import { useCart } from "react-use-cart";
import { UrlPath } from "utility/routes";
import ProductList from "components/ProductList";
import { webShopService } from "services/Services";
import BulletpointsProduct from "./Products/BulletpointProduct";
import InfotextProduct from "./Products/InfotextProduct";
import ExtraLinksProduct from "./Products/ExtraLinksProduct";
import { Seo } from "components/Seo";


const WebshopProduct: React.FC = () => {

    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const cart = useCart();
    const [currentProduct, setCurrentProduct] = useState<WebshopProductModel | null>(null);
    const [existingProduct, setExistingProduct] = useState<WebshopProductModel | null>(null);
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState<WebshopProductModel[]>([]);
    const [formValid, setFormValid] = useState(false);

    let editElement: JSX.Element;
    let title: string | undefined;


    const handleAddProduct = (product: WebshopProductModel | null) => {
        setCurrentProduct(product);
    }
    const handleAbort = () => {
        setCurrentProduct(null);
    }

    const handleAddToCart = () => {
        if (currentProduct !== undefined && currentProduct !== null) {
            let existingProduct = cart.getItem(currentProduct?.id);
            if (existingProduct) {
                cart.updateItem(existingProduct.id, currentProduct);
            }
            else {
                cart.addItem(currentProduct);
            }

            setExistingProduct(currentProduct);
        }
    }

    useEffect(() => {

        var getProducts = async () => {
            const fetchedProducts = await webShopService.getProducts();
            if (fetchedProducts !== undefined) setProducts(fetchedProducts)
        }
        getProducts();
        resetProductState();

    }, []);

    useEffect(() => {
        resetProductState();
    }, [location.pathname]);

    const resetProductState = () => {
        setLoading(true);
        setCurrentProduct(null);
        const key = `${params?.product ?? ''}${params?.id ?? ''}`;
        let existingProduct = cart.getItem(key);
        if (existingProduct !== undefined) {
            setCurrentProduct(existingProduct);
            setExistingProduct(existingProduct);
        }
        else {
            setCurrentProduct(null);
            setExistingProduct(null);
        }
        setLoading(false);
    }

    const handleFormValidation = (valid: boolean) => {
        setFormValid(valid);

    }



    switch (params.product) {
        case "logo": {
            title = "Vis logo";
            editElement = <LogoProduct handleAddProduct={handleAddProduct} initialProduct={existingProduct} handleFormValidation={handleFormValidation} />
            break;
        }
        case "punktliste": {
            title = "Punktliste: Bedriftens varer og tjenester";
            editElement = <BulletpointsProduct handleAddProduct={handleAddProduct} initialProduct={existingProduct} handleFormValidation={handleFormValidation} />
            break;
        }
        case "beskrivelse": {
            title = "Beskrivelse av bedriften";
            editElement = <InfotextProduct handleAddProduct={handleAddProduct} initialProduct={existingProduct} handleFormValidation={handleFormValidation} />
            break;
        }
        case "ekstra-lenker": {
            title = "Ekstra lenker";
            editElement = <ExtraLinksProduct handleAddProduct={handleAddProduct} initialProduct={existingProduct} handleFormValidation={handleFormValidation} />
            break;
        }
        default: {
            title = "Produktet mangler";
            editElement = <>Kunne ikke hente produktet.</>
            break;
        }
    }
    return <>
        <BreadcrumbCompany />
        <Seo title={"Nettbutikk - " + title}/>
        <div className="card">
            <div className="card-body">
                <h1 className="h3">{title}</h1>
                {title !== undefined && title !== "Produktet mangler" ? <>
                    <p className="lead mb-1">
                        Pris kr. {
                            (() => {
                                const product = products.find(x => x.path === params.product);
                                if (!product) return "Ukjent";
                                return product.price;
                            })()
                        },- pr år.
                    </p>

                    <p className="text-muted">Fornyes automatisk tre måneder før endt periode. Oppsigelse må skje før dette.</p></> : null}
                {!loading ? editElement : null}
                <div className="d-md-flex justify-content-between align-items-center mb-0 mt-4">
                    <div className="order-first">
                        <button type="button" onClick={handleAddToCart} className="btn btn-primary me-1" disabled={currentProduct === undefined || currentProduct === null || !formValid} data-bs-toggle="modal" data-bs-target="#modalAddToCart"> {existingProduct === null ? "Legg i handlekurv" : "Oppdater handlekurv"} </button>
                        <button onClickCapture={() => navigate(-1)} className="btn btn-outline-primary" onClick={handleAbort} >Avbryt</button>
                    </div>
                </div>

            </div>
            <AddToCartModal name={currentProduct?.name ?? "Produktet"} />
        </div>
        <ProductList />
    </>
}

export default WebshopProduct;